// MEALUP mobile helpers (sitewide):
// 1. Sideways rows: when a row really scrolls, fade its right edge and put a round arrow over it;
//    the arrow scrolls the row and turns back at the end, the fade goes away at the end of the row.
// 2. Long lists on phones (FAQ, Judge.me reviews): show the first few, then a "show more" button.
(function () {
  const S = window.muStrings || {};
  const ROWS = '.mu-feq__list, [class^="ai-step-process-cards-"], .mu-subtl__list, .mu-pdp-videos__list, .mu-hrec__strip, .mu-pdp-tiles, .mu-uc__grid, [data-mu-swipe]';
  const bound = new WeakSet();
  function setup(el) {
    if (bound.has(el)) return;
    const cs = getComputedStyle(el);
    if (!/(auto|scroll)/.test(cs.overflowX)) return;
    if (el.scrollWidth <= el.clientWidth + 8) return;
    bound.add(el);
    el.classList.add('mu-swipe');
    // a round arrow over the right edge of the row (Iliyan, 2026-10-23: an arrow, no "swipe" text);
    // it scrolls the row on click and turns back at the end. The holder has no height, so the layout stays as it is.
    const nav = document.createElement('div');
    nav.className = 'mu-swipe-nav';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mu-swipe-arrow';
    btn.setAttribute('aria-label', S.next || '→');
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    nav.appendChild(btn);
    el.after(nav);
    const place = () => {
      const s = getComputedStyle(el);
      nav.style.setProperty('--mu-row-h', el.offsetHeight + 'px');
      nav.style.setProperty('--mu-row-mb', s.marginBottom);
      nav.style.setProperty('--mu-row-mr', s.marginRight);
      nav.classList.toggle('is-off', el.scrollWidth <= el.clientWidth + 8);
    };
    const update = () => {
      const end = el.scrollLeft + el.clientWidth >= el.scrollWidth - 8;
      el.classList.toggle('mu-swipe--end', end);
      nav.classList.toggle('is-end', end);
      btn.setAttribute('aria-label', (end ? S.prev : S.next) || '→');
    };
    place();
    if (window.ResizeObserver) new ResizeObserver(place).observe(el);
    btn.addEventListener('click', () => {
      if (nav.classList.contains('is-end')) el.scrollTo({ left: 0, behavior: 'smooth' });
      else el.scrollBy({ left: Math.max(el.clientWidth * 0.8, 120), behavior: 'smooth' });
    });
    el.addEventListener('scroll', update, { passive: true });
  }
  const scan = () => document.querySelectorAll(ROWS).forEach(setup);

  const phone = window.matchMedia('(max-width: 749px)');
  function clamp(list, items, keep, label) {
    if (!list || list.dataset.muClamp || items.length <= keep + 1) return;
    list.dataset.muClamp = '1';
    items.slice(keep).forEach((it) => { it.hidden = true; it.classList.add('mu-clamped'); });
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mu-more-btn';
    btn.textContent = (label || S.more || '+') + ' (' + (items.length - keep) + ')';
    btn.addEventListener('click', () => {
      items.forEach((it) => { it.hidden = false; });
      btn.remove();
    });
    list.after(btn);
  }
  function clampAll() {
    if (!phone.matches) return;
    const faq = document.querySelector('.mu-pdp-faq__list');
    if (faq) clamp(faq, [...faq.children], 6, S.moreFaq);
    const jm = document.querySelector('.jdgm-rev-widg__reviews');
    if (jm) clamp(jm, [...jm.querySelectorAll(':scope > .jdgm-rev')], 2, S.moreReviews);
  }

  const run = () => { scan(); clampAll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', scan, { passive: true });
  // Judge.me and lazy blocks render late: watch for them for a while
  const mo = new MutationObserver(() => { clearTimeout(mo.t); mo.t = setTimeout(run, 250); });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => mo.disconnect(), 15000);
})();
